import { isMacOS } from './getContextInfo';

export default function hasFullscreenModiferKeys(event) {
  const isMac = isMacOS;
  const isCtrlOrCmd = (!isMac && event.ctrlKey) || (isMac && event.metaKey);

  return isCtrlOrCmd && event.shiftKey;
}
